import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import cx from 'classnames';
import styles from './timelines.module.scss';
import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import PlusIcon from '@cp/src/assets/icons/PlusIcon';
import CreateTimelineDrawer from './createTimelineDrawer';
import AgTable from '@navi/web-ui/lib/components/AgTable/AgTable';
import { TIMELINES_COL_DEFS } from './timelinesColDefs';
import { noop } from '@navi/web-ui/lib/utils/common';
import Pagination from '@navi/web-ui/lib/components/Pagination/Pagination';
import { DropDownPosition } from '@navi/web-ui/lib/components/Pagination/constant';
import { getTimelinesByTenant } from '../paramountActions';
import { useDispatch, useSelector } from 'react-redux';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';
import { RootState } from '@cp/src/store';

const Timelines = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const columnData = TIMELINES_COL_DEFS();
  const [showUploadHistory, setShowUploadHistory] = useState(false);
  const handleCreateProduct = () => {
    setShowUploadHistory(true);
  };
  const tenant = useGetTenant();

  const timelines = useSelector((state: RootState) => state.paramountSlice.timelines);
  useEffect(() => {
    dispatch(getTimelinesByTenant(tenant));
  }, []);

  const [searchParams] = useSearchParams();

  const productCode = searchParams.get('product') || '';

  const filteredTimelines = timelines.filter(timeline => {
    return timeline.productCodes.includes(productCode);
  });

  return (
    <div className={styles.timelinesPage}>
      <div className={styles.topNavContainer}>
        <div className={cx('cursor-pointer')} onClick={() => navigate(-1)}>
          <BackIcon size={'16'} />
        </div>
      </div>
      <div className="flex flex-row justify-between p-[20px]">
        <Typography variant="h2">Timelines</Typography>
        <Button
          variant="primary"
          size="medium"
          startAdornment={<PlusIcon fillColor="white" />}
          onClick={handleCreateProduct}
        >
          Create Timeline
          <CreateTimelineDrawer
            showUploadDrawer={showUploadHistory}
            setShowUploadDrawer={setShowUploadHistory}
          />
        </Button>
      </div>
      <AgTable
        className={styles.timelinesTable}
        sizeColumnsToFit={true}
        columnDefs={columnData}
        rowData={productCode ? filteredTimelines : timelines}
        onGridReady={noop}
        defaultColDef={{
          suppressMovable: true,
          wrapText: true
        }}
        style={{
          height: 575,
          width: '97%'
        }}
        theme={'alpine'}
        alternateRowColor="var(--greyscale-content-5)"
        paginationWrapperClasses={'paginationWrapperClasses'}
        PaginationComponent={
          <Pagination
            pageSize={0}
            currentPage={0}
            totalCount={20}
            onPageChange={noop}
            onPageSizeChange={noop}
            pageNumberDropDownPosition={DropDownPosition.TOP}
          />
        }
      />
    </div>
  );
};

export default Timelines;
